import Icon from '../components/Icon.vue'

Icon.register({"arrows-v":{"width":768,"height":1792,"paths":[{"d":"M704 320q0 26-19 45t-45 19h-128v1024h128q26 0 45 19t19 45-19 45l-256 256q-19 19-45 19t-45-19l-256-256q-19-19-19-45t19-45 45-19h128v-1024h-128q-26 0-45-19t-19-45 19-45l256-256q19-19 45-19t45 19l256 256q19 19 19 45z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/arrows-v.js
// module id = 856
// module chunks = 0